import React, { type HTMLAttributes } from 'react';
import classNames from 'classnames';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { Container, WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import type { ParagraphQuote as Type } from '../../../../types/uncinc_profile/paragraphs';
import { DynamicMediaItem } from '../../../../components';

import './style.scss';

interface ParagraphQuoteProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphQuote: React.FC<ParagraphQuoteProps> = ({ id, entity }) => {
  const paragraphQuote = entity.toJS();

  const quote = paragraphQuote.field_body[0].processed;
  const authorName = paragraphQuote.field_name[0]?.value;
  const authorFunction = paragraphQuote.field_label[0]?.value;
  const authorProfilePicture = paragraphQuote.field_profile_picture[0];

  const containerClasses = classNames('Paragraph', 'ParagraphQuote');

  return (
    <div id={id} className={containerClasses}>
      <Container>
        <div className="row">
          <div className="col-md-10 offset-md-1 col-lg-8 offset-lg-2">
            <div className="ParagraphQuote__text-wrapper">
              <div className="ParagraphQuote__text">
                <WysiwygField
                  className="ParagraphQuote__quote quote"
                  property="schema:text"
                  html={quote}
                />
                <div className="ParagraphQuote__author">
                  {authorProfilePicture && (
                    <DynamicMediaItem
                      className="ParagraphQuote__author__profile-picture"
                      media={authorProfilePicture}
                      imageAspectRatio="1_1"
                    />
                  )}
                  <div className="ParagraphQuote__author__info">
                    {authorName && (
                      <div className="ParagraphQuote__author__info__name">
                        {authorName}{authorFunction ? ',' : ''}
                      </div>
                    )}
                    {authorFunction && (
                      <span className="ParagraphQuote__author__info__function">
                        {authorFunction}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ParagraphQuote;
